import { render, staticRenderFns } from "./CostBearerEdit.vue?vue&type=template&id=754679c0"
import script from "./CostBearerEdit.vue?vue&type=script&lang=ts"
export * from "./CostBearerEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports